module.exports = __webpack_public_path__ + "static/media/not-started-check-activity-icon.462ebd33.svg";